
  import * as strapiRuntime$O29FWYUNpVGDgzaDWlLvYmbc126q26vqQaoZ54N4fcU from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_@capacitor+preferences@7.0.2_@capacitor+core@7.3.0__db0@0.3.2_idb-ke_f16792b9ef009620f0f18ee93df24b11/node_modules/@nuxt/image/dist/runtime/providers/strapi'
import * as belongRuntime$SqKuZtrwoACNXnqD9XXrClJfRn88rzdf1fC3PPAZI3Q from '/app/apps/website/app/providers/s3-belong.ts'
import * as ipxRuntime$Yf6t8q_x9of0F28G1kEyAoKnEFMGBvRSxK2TMlIS9yw from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_@capacitor+preferences@7.0.2_@capacitor+core@7.3.0__db0@0.3.2_idb-ke_f16792b9ef009620f0f18ee93df24b11/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['strapi']: { provider: strapiRuntime$O29FWYUNpVGDgzaDWlLvYmbc126q26vqQaoZ54N4fcU, defaults: undefined },
  ['belong']: { provider: belongRuntime$SqKuZtrwoACNXnqD9XXrClJfRn88rzdf1fC3PPAZI3Q, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$Yf6t8q_x9of0F28G1kEyAoKnEFMGBvRSxK2TMlIS9yw, defaults: {} }
    }
  }
